
import Menu from "./index";
export default Menu;
